import Head from "next/head";

export type HomeHeaderProps = {
  title: string;
};

export default function HomeHeader(props: HomeHeaderProps): JSX.Element {
  const { title } = props;
  return (
    <Head>
      <title>{title} | Myedvault</title>
      <meta
        name="description"
        content="MyEdvault is an all-in-one SaaS training platform for hosting online courses and e-learning services. Simplify training with one integrated solution"
      />
      <meta
        name="keywords"
        content="SaaS training platform, MyEdvault,online training, schools, e-learning, online courses, manage courses, track learning progress, learning"
      />
      <meta charSet="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
    </Head>
  );
}
